<h2 mat-dialog-title id="dialogTitle">{{ data.header }}</h2>

<mat-dialog-content role="document">
  <section aria-labelledby="dialogTitle">
    <mat-label *ngFor="let content of data.content">{{ content }}<br></mat-label><br>
    <ng-container *ngIf="data.param === 'rating'">
      <ngb-rating  style="font-size: 40px" [(rate)]="rating" 
        class="rating"
        aria-label="Rate your experience from 1 to 10"
      ></ngb-rating>

      <div class="rating-scale">
        <span>1-3 : Poor</span>
        <span style="margin-left: 2.2rem; margin-right: 2.2rem;">4-7 : Average</span>
        <span>8-10 : Excellent</span>
      </div>
      <p style="margin-top: 2rem;"><strong>Your rating is: {{ rating }}</strong></p>
    </ng-container>
    <mat-form-field class="full-width">
        <label for="feedback">Feedback if any</label>
        <textarea id="feedback"[(ngModel)]="feedback" matInput rows="3" maxlength="500"aria-describedby="charCount"></textarea>
      </mat-form-field>
    <span id="charCount" class="text-right" aria-live="polite">{{ feedback.length }}/{{ MAX_COMMENTS_LENGTH }} characters remaining *</span>
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button 
    mat-button 
    mat-dialog-close 
    cdkFocusInitial 
    class="btn btn-primary-outline modal-btn-1"
    [class.disabled-button]="isSubmitDisabled()"
    [disabled]="isSubmitDisabled()"
    (click)="submit()"
    >
    {{ data.actions[0] }}
    </button>
</mat-dialog-actions>
